import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ReactComponent as MenuIndicator } from 'components/Spoiler/images/menu-indicator.svg';
import styles from './Pagination.module.scss';
import { range, union } from 'lodash';

const PAGE_LIMIT = 2;
const PAGE_GROUP_SEPARATOR = '...';
class Pagination extends Component {
  static propTypes = {
    currentPage: PropTypes.number.isRequired,
    pagesNumber: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  toNextPage = (directionFlag) => {
    const { currentPage, pagesNumber, onChange } = this.props;
    let page;

    if (directionFlag) {
      page = currentPage < pagesNumber ? currentPage + 1 : pagesNumber;
    } else {
      page = currentPage > 1 ? currentPage - 1 : 1;
    }

    onChange(page);
  };

  getShowedPages = () => {
    const { currentPage, pagesNumber } = this.props;
    let pages = [1];
    let upperBound = currentPage + PAGE_LIMIT;
    let lowerBound = currentPage - PAGE_LIMIT;
    upperBound = upperBound < pagesNumber ? upperBound : pagesNumber;
    lowerBound = lowerBound > 1 ? lowerBound : 1;

    if (lowerBound - 1 > 1) {
      pages.push(PAGE_GROUP_SEPARATOR);
    }

    const pagesRange = range(lowerBound, upperBound + 1);
    pages = union(pages, pagesRange);

    if (pagesNumber - upperBound > 1) {
      pages.push(PAGE_GROUP_SEPARATOR);
    }

    if (upperBound !== pagesNumber) {
      pages.push(pagesNumber);
    }

    return pages;
  };

  renderPageButtons = () => {
    const { currentPage, onChange } = this.props;
    let pageNumbers = this.getShowedPages();
    return pageNumbers.map((pageNumber, index) => {
      const pageClassName = classnames(styles.paginationItem, {
        [styles.selected]: pageNumber === currentPage,
      });
      const dotsClasses = classnames('pagination_item noactive', styles.dots);
      return pageNumber === PAGE_GROUP_SEPARATOR ? (
        <span key={index} className={dotsClasses}>
          {pageNumber}
        </span>
      ) : (
        <a
          key={index}
          className={pageClassName}
          onClick={() => pageNumber !== currentPage && onChange(pageNumber)}
        >
          {pageNumber}
        </a>
      );
    });
  };

  renderIcon = (className, onClick, isRight) => {
    return (
      <div className={className} onClick={() => onClick(isRight)}>
        <MenuIndicator />
        {isRight ? (
          <span className="replace_text replace_text__second">Далее</span>
        ) : (
          <span className="replace_text replace_text__first">Назад</span>
        )}
      </div>
    );
  };
  render() {
    const { currentPage, pagesNumber } = this.props;
    const prevButtonClasses = classnames(styles.left, { [styles.noactive]: currentPage === 1 });
    const nextButtonClasses = classnames(styles.right, {
      [styles.noactive]: currentPage === pagesNumber,
    });
    return (
      <div className={`${styles.paginationBlock}`}>
        <div className={`${styles.paginationButtons}`}>{this.renderPageButtons()}</div>
        <div className={`${styles.paginationArrows}`}>
          {this.renderIcon(prevButtonClasses, this.toNextPage, false)}
          {this.renderIcon(nextButtonClasses, this.toNextPage, true)}
        </div>
      </div>
    );
  }
}
export default Pagination;
// export {default} from './PaginationNew';
